import 'react-pdf/dist/Page/TextLayer.css'
import { AttachmentView } from './Attachments'
import './styles.css'

import { Box, Center, Spinner } from '@chakra-ui/react'
import { AnimatePresence } from 'framer-motion'
import { useMemo, useRef } from 'react'
import { Page } from 'react-pdf'
import { PdfViewPage } from './types'

export const PdfPage = ({
  page,
  index,
  pageWidth,
  viewWidth,
  pageHeight,
}: {
  page: PdfViewPage
  index: number
  pageWidth: number
  viewWidth: number
  pageHeight: number
}) => {
  const pageRef = useRef<HTMLDivElement>(null)
  const pageAspect = useMemo(() => pageWidth / pageHeight, [pageWidth, pageHeight])
  const pageScale = useMemo(() => viewWidth / pageWidth, [viewWidth, pageWidth])
  return (
    <Box
      ref={pageRef}
      className="pdf-view-page-container"
      key={`page_${index}`}
      width={`${viewWidth}px`}
      position="relative">
      {page.type === 'file' ? (
        <Box position="relative">
          <Page
            className="pdf-view-page"
            loading={
              <Center w={`${viewWidth}px`} h={`${pageHeight}px`}>
                <Spinner />
              </Center>
            }
            width={viewWidth}
            height={pageHeight * pageAspect}
            pageNumber={index + 1}
          />
          <AnimatePresence>
            {page.attachments.map(attachment => (
              <AttachmentView
                pageHeight={pageHeight}
                pageScale={pageScale}
                pageWidth={pageWidth}
                key={attachment.id}
                attachment={attachment}
              />
            ))}
          </AnimatePresence>
        </Box>
      ) : (
        <AttachmentView
          attachment={page.attachment}
          pageScale={pageScale}
          pageWidth={pageWidth}
          pageHeight={pageHeight}
        />
      )}
    </Box>
  )
}
